<template>
  <div class="md:rounded-xl md:border border-solid bg-neutral-white md:shadow-xl md:p-16 p-8 space-y-12">
    <div v-if="$slots.title || $slots.subTitle" class="space-y-4 text-center">
      <div class="font-semibold headline-text">
        <slot name="title" />
      </div>

      <div v-if="$slots.subTitle" class="text-typography-secondary">
        <slot name="subTitle" />
      </div>
    </div>

    <div>
      <slot />
      <div v-if="!isBlockedPage" class="flex justify-center mt-3">
        <NuxtLink
          v-if="showRestartClaimButton"
          class="text-primary-700 flex items-center gap-2 cursor-pointer justify-center"
          @click="handleResetClaim"
        >
          <PulseLineRefresh class="h-4 w-4 fill-current" />
          <span class="whitespace-nowrap">Restart Claim</span>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useClaimStore } from '@pulse/composables/useClaimStore';
import { useOrdersStore } from '@pulse/composables/useOrdersStore';
import { storeToRefs } from 'pinia';

interface Order {
  customerEmail: string;
  orderNumber: string;
}

const runtimeConfig = useRuntimeConfig();
const claimStore = useClaimStore(runtimeConfig)();
const orderStore = useOrdersStore(runtimeConfig)();
const route = useRoute();
const { currentOrder }: { currentOrder: Ref<Order | null> } = storeToRefs(orderStore);

defineProps({
  showRestartClaimButton: {
    default: true,
    type: Boolean,
  },
});

async function handleResetClaim() {
  if (!currentOrder.value) return;

  await claimStore.deleteClaimSession();

  navigateTo(`/start?email=${currentOrder.value.customerEmail}&order=${currentOrder.value.orderNumber}`);
}

const isBlockedPage = computed(() => {
  const blockedPages = ['start', 'claim-received', 'too-late', 'not-shipped', 'too-soon', 'in-store'];
  const path = route.path || '';

  return blockedPages.some(page => path.includes(page));
});
</script>
